import { settle } from '@gonfalon/async/settle';
import { patchFeatureFlag } from '@gonfalon/openapi/operations/patchFeatureFlag';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';
import { getFeatureFlagQuery } from '../queries/flags';

export async function updateFlagSemantically({
  projectKey,
  flagKey,
  environmentKey,
  instructions,
  ignoreConflicts,
  comment,
}: {
  projectKey: string;
  flagKey: string;
  environmentKey?: string;
  instructions: unknown[];
  ignoreConflicts: boolean;
  comment?: string;
}) {
  const queryClient = getQueryClient();

  const [result, error] = await settle(async () =>
    reactQueryResponseAdapter(
      patchFeatureFlag(
        {
          projectKey,
          featureFlagKey: flagKey,
          query: { ignoreConflicts },
          body: {
            comment,
            environmentKey,
            instructions,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json; domain-model=launchdarkly.semanticpatch',
          },
        },
      ),
    ),
  );

  if (error) {
    throw error;
  }

  // TODO: This should be more targeted (to only invalidate queries for this specific flag),
  // but in practice if we're updating a specific flag it should be the only one with active
  // detail queries
  await queryClient.invalidateQueries({
    queryKey: getFeatureFlagQuery({ projectKey, featureFlagKey: flagKey }).queryKey,
  });

  return result;
}
